import alert from '@/plugins/alert'
import { Asset } from '@/plugins/api'
import { rangeRight } from 'lodash'

export default {
  namespaced: true,
  state: {
    loading: false,
    assetData: {},
    count: 0,
    pageText: '',
    itemsPerPage: 10,
    assetSearchParams: {},
    totalItems: 0,
    assets: []
  },
  actions: {
    async searchAssetList({ commit, state, dispatch }, query) {
      const assetSearchParams = {
        isDelete: false,
        _limit: state.itemsPerPage,
        ...query
      }
      commit('changeState', { assetSearchParams })
      dispatch('requestPageSettings', {})
    },

    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage

      if (state.assetSearchParams) {
        const assetSearchParams = {
          ...state.assetSearchParams,
          isDelete: false,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'createdAt:DESC'
        }

        const [totalItems, assets] = await Promise.all([
          Asset.count(assetSearchParams),
          Asset.search(assetSearchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            assets,
            totalItems,
            itemsPerPage,
            assetSearchParams
          })
          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('setPageText', pageText)
        } else {
          const pages = rangeRight(1, page)
          for (let index = 0; index < pages.length; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      commit('changeState', { loading: false })
    },

    async createAsset({ commit, state }, assetData) {
      try {
        const created = await Asset.create(assetData)
        commit('changeState', {
          assets: [created, ...state.assets]
        })
        alert.success('Thêm thiết bị thành công')
        return created
      } catch (e) {
        alert.error(e)
      }
    },

    async updateAsset({ commit }, { id, ...assetData }) {
      try {
        const updated = await Asset.update(id, assetData)
        commit('updateAsset', updated)
        alert.success('Cập nhật thiết bị thành công')
        return updated
      } catch (e) {
        alert.error(e)
      }
    },

    async removeAsset({ commit }, id) {
      try {
        await Asset.remove(id)
        commit('removeAsset', id)
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setPageText(state, pageText) {
      state.pageText = pageText
    },
    updateAsset(state, assetData) {
      state.assets = state.assets.map(a => (assetData.id === a.id ? assetData : a))
    },
    removeAsset(state, id) {
      state.assets = state.assets.filter(a => a.id !== id)
    },
    changeState(state, payload) {
      Object.assign(state, payload)
    }
  }
}
